<template>
  <div class="systemt">
    <div class="title">
      <div class="titleT">系统赋能</div>
    </div>
    <ul>
      <li v-for="(i,index) in list" :key="index">
        <div class="img iconfont" :class="i.img"></div>
        <div class="info">
          <div class="name">{{i.name}}</div>
          <div class="desc">{{i.desc}}</div>
        </div>
        <div class="button">立即体验</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'systemt',
  data () {
    return {
      list: [{
        img: 'icon-duihuan',
        name: '积分兑换系统',
        desc: '商城产品总量扩、商城价格阶梯优化、多仓直发网络布局、无忧售后服务保障'
      },{
        img: 'icon-hongbao1',
        name: '企业福利内购系统',
        desc: '打造企业年节福利，数字化新通道，配置企业专属员工，放心购平价商城'
      },{
        img: 'icon-shangcheng1',
        name: '社区商城系统',
        desc: '资源优享+系统赋能；实现社区直购，助力团长创业；链接京东自营、区域商家、全力构建社区高质低价购物新生态'
      },{
        img: 'icon-qia',
        name: '卡册兑换系统',
        desc: '全方位卡册企业赋能，免费开放卡册系统应用'
      }]
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style lang="stylus" scoped>
.systemt
  margin-top px(60)
  padding 0 px(20)
  margin-bottom px(50)
  ul
    margin-top px(27)
    li
      width 100%
      display flex
      margin-top px(13)
      border 1px solid #D22016
      padding px(20)
      align-items center
      .img
        min-width px(76)
        min-height px(76)
        margin 0 px(24) 0 px(10)
        border-radius 50%
        background #D22016
        font-size px(54)
        color #fff
        text-align center
        line-height px(76)
      .info
        width flex
        padding-right px(20)
        .name
          font-size px(26)
          color #333333
          margin-bottom px(19)
        .desc
          color #666666
          font-size px(22)
      .button
        min-width px(120)
        min-height px(44)
        font-size px(20)
        line-height px(44)
        border-radius px(6)
        background #D22016
        text-align center
        color #fff
</style>



// WEBPACK FOOTER //
// src/pages/index/components/system.vue